export const TRANSPARENCIA_SWAGGER_URL =
  'https://api.portaldatransparencia.gov.br/swagger-ui/index.html';

export const TRANSPARENCIA_OPENAPI_URL = 'https://api.portaldatransparencia.gov.br/v3/api-docs';

export const TRANSPARENCIA_CADASTRO_URL = 'https://portaldatransparencia.gov.br/';

export const TRANSPARENCIA_ADAPTER_PACKAGE = '@br-validators/adapters-transparencia';

export const TRANSPARENCIA_GOLDEN_CEIS_PATH = '/api-de-dados/ceis';
